export default [
  {
    title: "№",
    name: "order",
    type: "order",
    sortable: false,
  },
  {
    title: "Маркировка на фабрике",
    name: "factoryMarking",
    editor: false,
    component: "text",
    sortable: false,
    align: "left",
  },
  {
    title: "Производитель",
    name: "manufacturer",
    type: "object",
    sortable: false,
    align: "left",
  },
  {
    title: "TM",
    name: "trademark",
    type: "object",
    sortable: false,
    align: "left",
  },
  {
    title: "Модель",
    name: "model",
    type: "object",
    sortable: false,
    align: "left",
  },
  {
    title: "Артикул",
    name: "article",
    type: "object",
    sortable: false,
    align: "left",
    cellFiltering: true,
  },
  {
    title: "Номенклатура",
    name: "nomenclature",
    type: "object",
    sortable: false,
    align: "left",
    cellFiltering: true,
  },
  {
    title: "Материал",
    name: "material",
    editor: false,
    component: "text",
    sortable: false,
    align: "left"
  },
  {
    title: "Габаритный размер товара",
    name: "size",
    editor: false,
    component: "text",
    sortable: false,
    width: "80",
  },
  {
    title: "Страна происхождения",
    name: "country",
    sortable: false,
    width: "95",
    editor: false,
    component: "reference",
    resource: "countries",
    referenceComponent: "Country",
  },
  {
    title: "Количество, ШТ",
    name: "quantity",
    editor: false,
    component: "decimal",
    sortable: false,
    align: "left",
  },
  {
    title: "Ед. изм.",
    name: "unit",
    type: "object",
    sortable: false,
    align: "left",
    width: "50",
  },
  {
    title: "Вес netto",
    name: "weightNetto",
    editor: false,
    component: "decimal",
    sortable: false,
    width: "50",
  },
  {
    title: "Вес brutto",
    name: "weightBrutto",
    editor: false,
    component: "decimal",
    sortable: false,
    width: "50",
  },
  {
    title: "Количество мест",
    name: "places",
    editor: false,
    component: "decimal",
    sortable: false,
    align: "left",
    width: "50",
  },
  {
    title: "Объем",
    name: "volume",
    editor: false,
    component: "decimal",
    sortable: false,
  },
  {
    title: "Стоимость",
    name: "cost",
    editor: false,
    component: "decimal",
    sortable: false,
    align: "left",
  },
  {
    title: "Валюта",
    name: "currency",
    editor: false,
    sortable: false,
    align: "left",
  },
  {
    title: "Сайт товара",
    name: "goodSite",
    type: "link",
    sortable: false,
    align: "left",
  },
  {
    title: "Таможенный код",
    name: "customsNumber",
    editor: false,
    component: "text",
    sortable: false,
    align: "left",
    width: "80",
  },
  {
    title: "Категория",
    name: "productCategory",
    editor: false,
    component: "reference",
    resource: "product-categories",
    referenceComponent: "ProductCategory",
    sortable: false,
    align: "left",
  },
  {
    title: "Комментарий",
    name: "notes",
    editor: false,
    component: "text",
    sortable: false,
    align: "left",
  },
  { title: "", name: "menu", type: "menu", sortable: false },
];